import { lazy }  from "react";
import ReactDOM from "react-dom";
import { Provider } from 'react-redux'
import { useCheckAccess } from "./hooks/useCheckAccess";
import { store } from './store.js'
import Loadable from "./General/Loadable.jsx";
import { setEntry } from "./EntryHelpers/setEntry.js";
import { useRootCssVars } from "./hooks/useRootCssVars.js";

const PageFrontOverview = Loadable(lazy(() => import("./PageFrontOverview/index.jsx")))

const AccessWrapperFrontOverview  = ({isWebApp, isMobile}) => {
    const useAccesTheme = useCheckAccess() 
    useRootCssVars(useAccesTheme)

    if(useAccesTheme) {
        const PageFrontOverviewAccess = Loadable(lazy(() => import( "./PageFrontAccess/PageFrontOverviewAccess.jsx")))

        return <PageFrontOverviewAccess /> 

    } else {
        return <PageFrontOverview isMobile={isMobile} isWebApp={isWebApp}/>
    }
}

const elem = document.querySelector("#overview-page-front")

if(elem)  {
    const [isWebApp, isMobile] = setEntry()

    ReactDOM.render(
        <Provider store={store}>
            <AccessWrapperFrontOverview isWebApp={isWebApp} isMobile={isMobile}/>
        </Provider>
    , elem)
}
